import React, { useEffect, useRef, useState } from "react";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

import { LICENCE_KEY }
from "../constants/charts";

am4core.addLicense(LICENCE_KEY);

export default function TrendSparkline(
{
    

    colour = "#5a9bd6",

    width = "120px",

    height = "26px"
})
{
	
	const [values] = useState(() =>
	{
	    let current =
	        10 + Math.random() * 10;

	    return Array.from(
	        { length: 8 },
	        () =>
	        {
	            current +=
	                (Math.random() - 0.45) * 3;

	            current =
	                Math.max(
	                    2,
	                    Math.min(
	                        30,
	                        current));

	            return Math.round(current);
	        });
	});
	
    const chartRef =
        useRef(null);

    useEffect(() =>
    {
        const chart =
            am4core.create(
                chartRef.current,
                am4charts.XYChart);

        chart.padding(0,0,0,0);

        chart.maskBullets = false;

        chart.hiddenState.properties.opacity = 1;

        chart.defaultState.transitionDuration = 0;
        chart.hiddenState.transitionDuration = 0;

        chart.data =
            values.map(
                (value,index) =>
                ({
                    x: index,
                    value
                }));

        /*==============================================
         *
         * Axes
         *
         ==============================================*/

        const categoryAxis =
            chart.xAxes.push(
                new am4charts.CategoryAxis());

        categoryAxis.dataFields.category = "x";

        categoryAxis.renderer.grid.template.disabled = true;
        categoryAxis.renderer.labels.template.disabled = true;
        categoryAxis.renderer.baseGrid.disabled = true;
        categoryAxis.renderer.minGridDistance = 1;

        const valueAxis =
            chart.yAxes.push(
                new am4charts.ValueAxis());

        valueAxis.renderer.grid.template.disabled = true;
        valueAxis.renderer.labels.template.disabled = true;
        valueAxis.renderer.baseGrid.disabled = true;

        valueAxis.strictMinMax = false;

        /*==============================================
         *
         * Series
         *
         ==============================================*/

        const series =
            chart.series.push(
                new am4charts.LineSeries());

        series.dataFields.categoryX = "x";
        series.dataFields.valueY = "value";

        series.stroke =
            am4core.color(colour);

        series.strokeWidth = 2;

        series.fillOpacity = 0;

        series.tensionX = 0.85;

        series.tooltip.disabled = true;

        /*==============================================
         *
         * End Bullet
         *
         ==============================================*/

        const bullet =
            series.bullets.push(
                new am4charts.CircleBullet());

        bullet.propertyFields.disabled = "disabled";

        bullet.circle.radius = 3;

        bullet.circle.fill =
            am4core.color(colour);

        bullet.circle.stroke =
            am4core.color("#ffffff");

        bullet.circle.strokeWidth = 2;

        chart.data.forEach(
            (row,index) =>
            {
                row.disabled =
                    index !== chart.data.length - 1;
            });

        chart.cursor = undefined;

        return () =>
        {
            chart.dispose();
        };

    }, [values, colour]);

    return (

        <div
            ref={chartRef}

            style={{
                width,
                height
            }}
        />

    );
}